import { render, staticRenderFns } from "./SelectorTagsDocumentos.vue?vue&type=template&id=188ef639&scoped=true&"
import script from "./SelectorTagsDocumentos.vue?vue&type=script&lang=js&"
export * from "./SelectorTagsDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./SelectorTagsDocumentos.vue?vue&type=style&index=0&id=188ef639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ef639",
  null
  
)

export default component.exports